import * as React from 'react';
import {Dialog, DialogContent, DialogTitle, IconButton, ListItemText, Menu, MenuItem, withStyles, WithStyles} from '@material-ui/core';
import Button from '@components/common/button/Button';
import TranslateNew from '@translate/TranslateNew';
import { sharedMiscStyle } from './sharednote.style';
import CloseIcon from "@material-ui/icons/Close";
import { connect } from 'react-redux';
import { IAiNote, IListItem, ISharedNote } from '@app-types/websocket/sharedinfo.types';
import { buttonContainedLarge } from 'src/main.style';
import * as EventActions from "@services/events/event.action"
import { DialogTop } from '@components/economy/DialogComponens';
import { AI_TASK_TYPE, IAiTask } from '@app-types/websocket/event.types';
import { is } from 'redux-saga/utils';
import { IFamilyMember } from '@app-types/websocket/family.types';
import { FamilyMemberType } from '@services/family/family.constants';


const tn: TranslateNew = TranslateNew.getInstance();



interface IState {
  prompt:string,
  showMenu:boolean;
  
}

interface IProps extends WithStyles<typeof sharedMiscStyle> {
  noteId:number|undefined;  // 0 = new
  close:() => void;
  aiTask: (task:IAiTask) => void;

  family:IFamilyMember[];
  userId:number;

  sharedNotes: ISharedNote[];
  localNotes: ISharedNote[];

  createTemplate :(text:string, list:IListItem[]) => void;
  createNew: (callBack:(id:number) => void) => void; // create a new empty note and get a callback with the created note id
}

class AiNoteModal extends React.Component<IProps, IState> {

private exampleRef: React.RefObject<HTMLButtonElement> = React.createRef();

  constructor(props: IProps) {
    super(props);

    this.state = {
        prompt:"",
        showMenu:false,
      };
  }

  public componentDidUpdate(prevProps: Readonly<IProps>, prevState: Readonly<IState>, snapshot?: any): void {
      if (this.props.noteId !== prevProps.noteId && this.props.noteId !== undefined ) {
          this.setState({prompt:"", showMenu:false});
      }
  }

  public render() {
    const {classes} = this.props;

    return (
        <Dialog
            open={this.props.noteId !== undefined }
            onClose={this.props.close}
        >
            <DialogTop>
                <DialogTitle style={{justifyItems:'flex-start'}}>
                    {this.props.noteId===0?tn.lang.sharedNoteCreate:tn.lang.sharedNoteEdit}
                </DialogTitle>
                <IconButton onClick={() => this.props.close()}>
                    <CloseIcon />
                </IconButton>
            </DialogTop>
            <DialogContent>
                <textarea
                    autoCorrect={"on"}
                    rows={12}
                    spellCheck={true}
                    value={this.state.prompt}
                    onChange={(event) => {this.setState({prompt:event.target.value});}}
                    className={classes.greyInput}
                    style={{lineHeight:'16px', resize:'none', minWidth:'calc(100vw - 140px)'}}
                    placeholder={tn.lang.promptSharedNote}/>
            </DialogContent>
            <div style={{display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "row", 
                gap: "10px", margin: "8px 24px 24px"}}> 
                <Button onClick={() => this.setState({showMenu:true})} color="default" ref={this.exampleRef} >
                    {tn.lang.examples}
                </Button>
                <Button variant='contained' style={buttonContainedLarge} onClick={() => this.execute()} color="primary"
                    disabled={this.state.prompt.length < 5}>
                    {tn.lang.OK}
                </Button>
            </div>
            <Menu
                anchorEl={this.exampleRef.current}
                open={this.state.showMenu && this.props.noteId !== undefined}
                getContentAnchorEl={null}
                anchorReference="anchorEl"
                onClose={() => this.setState({showMenu:false})}
                anchorOrigin={{
                    vertical: 'center',
                    horizontal: 'right',
                  }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
                >
                {this.examples(this.props.noteId === 0)}
            </Menu>
        </Dialog>
    );
  }

  private examples = (newNote:boolean):JSX.Element[] => {
    if (newNote) {
        return ([/*
            <MenuItem onClick={() => { this.setState({showMenu:false, prompt:tn.lang.sharedNoteExamplePromptPrompt5});}} key={6}>
                <ListItemText>
                {tn.lang.sharedNoteExampleHandover}
                </ListItemText>
            </MenuItem>,
*/
            <MenuItem onClick={() => { this.setState({showMenu:false, prompt:tn.lang.sharedNoteExamplePromptPrompt1});}} key={1}>
                <ListItemText>
                {tn.lang.sharedNoteExamplePromptTitle1}
                </ListItemText>
            </MenuItem>,

            <MenuItem onClick={() => { this.setState({showMenu:false, prompt:tn.lang.sharedNoteExamplePromptPrompt2});}} key={2}>
                <ListItemText>
                {tn.lang.sharedNoteExamplePromptTitle2}
                </ListItemText>
            </MenuItem>,

            <MenuItem onClick={() => { this.setState({showMenu:false, prompt:tn.lang.sharedNoteExamplePromptPrompt3});}} key={3}>
                <ListItemText>
                {tn.lang.sharedNoteExamplePromptTitle3}
                </ListItemText>
            </MenuItem>,

            <MenuItem onClick={() => { this.setState({showMenu:false, prompt:tn.lang.sharedNoteExamplePromptPrompt4});}} key={4}>
                <ListItemText>
                {tn.lang.sharedNoteExamplePromptTitle4}
                </ListItemText>
            </MenuItem>,

            <MenuItem onClick={() => { this.setState({showMenu:false, prompt:tn.lang.sharedNoteExamplePromptPrompt5});}} key={5}>
                <ListItemText>
                {tn.lang.sharedNoteExamplePromptTitle5}
                </ListItemText>
            </MenuItem>,
            
        ]
        );
    } else {

        const coparent = this.props.family.find((m) => m.role === FamilyMemberType.PARENT && m.id !== this.props.userId);
        const coparentName = tn.familyMemberName(coparent?coparent.id:undefined, this.props.family);        
        const childrenNames = tn.familyMemberNames(this.props.family.filter((m) => m.role === FamilyMemberType.CHILD).map((m) =>m.id), 
            this.props.family);

        return ([
            <MenuItem onClick={() => { this.setState({showMenu:false, prompt:tn.lang.sharedNoteExampleEditPromptPrompt1});}} key={1}>
                <ListItemText>
                {tn.lang.sharedNoteExampleEditPromptTitle1}
                </ListItemText>
            </MenuItem>,

            <MenuItem onClick={() => { this.setState({showMenu:false, prompt:tn.lang.sharedNoteExampleEditPromptPrompt2});}} key={2}>
                <ListItemText>
                {tn.lang.sharedNoteExampleEditPromptTitle2}
                </ListItemText>
            </MenuItem>,

            <MenuItem onClick={() => { this.setState({showMenu:false, 
                prompt:tn.lang.sharedNoteExampleEditPromptPrompt3(coparentName, childrenNames)});}} key={3}>
                <ListItemText>
                {tn.lang.sharedNoteExampleEditPromptTitle3}
                </ListItemText>
            </MenuItem>,
        ]);
    }
  }

  private sendPrompt = (noteId:number) => {

    const note:ISharedNote|undefined = noteId > 0
        ?this.props.sharedNotes.find((n) => n.noteId === noteId)
        :this.props.localNotes.find((n) => n.noteId === noteId);

    let aiNote:IAiNote = {id: noteId,title: "Title",text: "",list: [],};

    if (note !== undefined) {
        aiNote = {
            id: note.noteId,
            title: note.serviceName,
            text: note.text,
            list: note.listItems?.filter((item) => item.deleted !== true)
                .map((item) => ({title:item.val, header:item.format === 2})) || [],
        };
    }

    const search:IAiTask = {
        promptOne:this.state.prompt,
        promptTwo:"",
        promptThree:JSON.stringify(aiNote),
        refObject:noteId,
        taskType:AI_TASK_TYPE.NOTE,
    }

    this.props.aiTask(search);
    
  }

  private executeHandoverNote = () => {
    this.props.createTemplate("Fyll i och tryck sedan övre hörnet och 'prompta'",[
        {format:0, val:""},
        {format:0, val:""},
        {format:0, val:""},
        {format:0, val:""},
        {format:0, val:""},
        {format:0, val:""},
        {format:0, val:""},
        {format:0, val:""},
        {format:0, val:""},
        {format:0, val:""},
        {format:0, val:""},
        {format:0, val:""},
        {val:"",format:0}]);
  }

  private execute = () => {

    if (this.props.noteId !== undefined ) {
        if (this.props.noteId === 0) {
            this.props.createNew((id) => {
                this.sendPrompt(id);
            });
        } else {
            this.sendPrompt(this.props.noteId);
        }
    }
    
    this.props.close();
  }

}


function mapStateToProps(state: any) {
  const userId = state.user.session.data.id;
  
  const localNotes: ISharedNote[] = state.notes.localSaves;
  const sharedNotes: ISharedNote[] = state.notes.sharedNotes?state.notes.sharedNotes:[];

  return {
    userId,
    localNotes,
    sharedNotes
  };
}

const mapDispatchToProps = {
    aiTask: EventActions.aiTask,
};


export default connect(mapStateToProps, mapDispatchToProps)(withStyles(sharedMiscStyle)(AiNoteModal));



// WEBPACK FOOTER //
// ./src/components/sharednotes/AiNoteModal.tsx